import { IAuditArea } from '../generic/auditText';

/**
 * Bereiche des Vorgangsprotokolls (#1330).
 *
 * Eigenes Modul, weil der Bereichsfilter sie inzwischen auch serverseitig
 * auflöst und ein Test sie prüfen können muss, ohne die ganze Vorgangsmaske
 * zu laden.
 */
export const ACTIVITY_LOG_AREAS: IAuditArea[] = [
  {
    label: 'Vorgang',
    entityTypes: [
      'LegalTransaction',
      'LegalTransactionRecordNumber',
      'LegalTransactionTransactionNumber',
      'LegalTransactionCustomId',
    ],
  },
  {
    label: 'Mandanten',
    entityTypes: [
      'LegalClient',
      'LegalTransactionLegalClient',
      'LegalRole',
      'LegalRole_canInvite',
    ],
  },
  {
    label: 'Abwicklung',
    entityTypes: [
      'LegalPhase',
      'LegalRequirement',
      'LegalRequirement_deadlines',
      'LegalRequirement_has_Document',
    ],
  },
  {
    label: 'Dokumente',
    entityTypes: [
      'Document',
      'LegalTransaction_has_Document',
      'DocumentDirectory',
      'DocumentDirectory_has_Document',
      'DocumentDownloaded',
      'DocumentRequested',
      'DocumentUploaded',
      'DraftMessage',
    ],
  },
  {
    label: 'Termine',
    entityTypes: [
      'LegalTransactionMeeting',
      'LegalTransactionMeetingRequest',
      'LegalTransactionMeetingEmail',
      'LegalTransactionMeeting_has_LegalClient',
    ],
  },
  {
    label: 'Aufgaben',
    /* `TaskUser`/`TaskUserGroup` tragen die Zuweisung. Ohne sie stand
       „Zuweisung „Aufgabe" → „Mitarbeiter1" hinzugefügt" als einzige Zeile
       ohne Chip da, und der Filter „Aufgaben" fand sie nicht. */
    entityTypes: [
      'Task',
      'TaskComment',
      'Task_has_Document',
      'TaskUser',
      'TaskUserGroup',
    ],
  },
  {
    label: 'Rechnungen',
    entityTypes: [
      'Invoice',
      'InvoicePaid',
      'InvoicePaidPlan',
      'InvoiceLegalClient',
    ],
  },
  { label: 'Notizen', entityTypes: ['LegalTransactionNote'] },
  /*
    Nachverfolgungen und Mails tragen als Entitaet die Akte selbst — sie haben
    keine eigene Tabelle im Protokoll, weil `ProcessManager` auf der Denylist
    steht. Der Bereich greift deshalb ueber den Ereignistyp.
  */
  {
    label: 'Nachverfolgung',
    entityTypes: [],
    eventTypes: ['process_manager.tracking_', 'mail.sent'],
  },
  /*
    Die Dokumentbereiche kommen aus dem Metadata des Ereignisses und sind
    deshalb ohne Entitaetsart oder Ereignistyp definiert: `areaLabel` liefert
    sie direkt, und Filter wie Chip benutzen dieselbe Funktion. Ohne diese
    Eintraege zeigte der Chip "Urkunden", die Auswahl kannte den Bereich aber
    nicht — und jede Filterung blendete genau diese Zeilen aus.
  */
  { label: 'Urkunden', entityTypes: [] },
  { label: 'Entwürfe', entityTypes: [] },
  { label: 'Öffentliche Dokumente', entityTypes: [] },
  {
    label: 'GwG',
    entityTypes: [
      'LegalTransactionGwG',
      'LegalTransactionGwGEntry',
      'LegalTransactionGwGEntry_has_Document',
    ],
  },
];
